<template>
    <div class="content" v-loading.fullscreen.lock="loading">
        <div class="content-c">
            <el-form ref="form" label-width="130px" :model="form" :label-position="labelPosition">
                <el-form-item label="项目code码:" prop="code">
                    <el-input v-model="form.code" placeholder="如:test"></el-input>
                </el-form-item>
                <el-form-item label="项目名字:" prop="name">
                    <el-input v-model="form.name" placeholder="如:测试"></el-input>
                </el-form-item>
                <el-form-item label="项目年份:" prop="year">
                    <el-input v-model="form.year" placeholder="如:2020"></el-input>
                </el-form-item>
                <el-form-item label="省份:" prop="district">
                    <el-input v-model="form.district" placeholder="如:江苏/山东"></el-input>
                </el-form-item>
                <el-form-item label="项目类型:" prop="type">
                    <el-radio v-model="type" label="0">预算</el-radio>
                    <el-radio v-model="type" label="1">决算</el-radio>
                </el-form-item>
                <el-form-item label="行政区划:" prop="ad">
                    <el-radio v-model="ad" label="省">省</el-radio>
                    <el-radio v-model="ad" label="市">市</el-radio>
                    <el-radio v-model="ad" label="区">区</el-radio>
                    <el-radio v-model="ad" label="县">县</el-radio>
                </el-form-item>
            </el-form>
            <el-button style="float:right;margin-top:20px" @click="edit">编辑</el-button>
        </div>
    </div>
</template>

<script>
    import { zones, edit } from '@/api/zone.js'
    export default {
        data() {
            return {
                form: {
                    code: '',
                    name: '',
                    year: '',
                    type: '',
                    district: '',
                    ad: '',
                },
                type: '0',
                ad: '省',
                labelPosition: 'left',
                loading: false
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                this.loading = true
                this.form.id = this.$cookies.get('zone')
                let host = window.location.host;
                let prefix = host.slice(0, host.indexOf("."));
                let openYear = Number('20' + host.split(".")[1].substring(0, 2))
                let openType = host.split(".")[1].substring(2, 4)
                let res = await zones({
                    code: prefix,
                    year: openYear,
                    type: openType,
                })
                if (res.status == 0) {
                    this.form.code = res.zones[0].code
                    this.form.name = res.zones[0].name
                    this.form.year = res.zones[0].year
                    this.form.type = res.zones[0].type
                    this.form.district = res.zones[0].district
                    this.ad = res.zones[0].ad
                    this.type = String(res.zones[0].type)

                }
                this.loading = false
            },
            async edit() {
                if (this.form.code == '' || this.form.name == '' || this.form.year == '' || this.type == '' || this.form.districk == '' || this.ad == '') {
                    this.$message.error('表单请填写完整!')
                } else {
                    this.loading = true
                    this.form.type = Number(this.type)
                    this.form.ad = this.ad
                    let editRes = await edit(this.form)
                    if (editRes.status == 0) {
                        localStorage.setItem('city', this.ad);
                        this.$message.success('编辑成功!')
                    }
                    this.loading = false
                }
            },
        }
    }
</script>

<style scoped>
    .content {
        padding-top: 100px;
        margin: 0 auto;
    }

        .content .content-c {
            width: 500px;
        }
</style>